import { useState, useEffect, useCallback } from 'react'
import FirmViewPolicy from 'src/components/portal/default/FirmViewComponents/FirmViewPolicy'
import { FirmDetailsPolicyData } from 'src/dtos/portal'
import { useAuth } from 'src/context/auth'
import { api } from 'src/services/apiClient'

const Policy = () => {
  const { user } = useAuth()
  const [firmDetailsPolicy, setFirmDetailsPolicy] = useState<FirmDetailsPolicyData | undefined>(undefined)
  
  const fetchPolicyDetails = useCallback(async () => {
    if(user?.firmId) {
      try {
        const { data } = await api.get(`/Firm/GetPolicyDetails/${user.firmId}`)

        setFirmDetailsPolicy(data)
      } catch(e) {
        setFirmDetailsPolicy(undefined)
      }
    } else {
      setFirmDetailsPolicy(undefined)
    }
  }, [user.firmId])

  useEffect(() => {
    fetchPolicyDetails()
  }, [fetchPolicyDetails])
  
  return (
    <div>
      <FirmViewPolicy policyData={firmDetailsPolicy} firmId={user.firmId} />
    </div>
  )
}

export default Policy